import React from 'react';

const AvailableLanguages = ({ entity }) => {
  const availableLanguages = entity.availableLanguages;
  const languageList =
    availableLanguages &&
    availableLanguages.map((item) => {
      return (
        <span
          style={{
            fontSize: '10px',
            color: 'black',
            backgroundColor: 'grey',
            borderRadius: '20px',
            marginLeft: '5px',
            padding: '2px',
          }}
        >
          {item.toUpperCase()}
        </span>
      );
    });
  return <div style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>{languageList}</div>;
};

export default AvailableLanguages;
